import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "category", "item"]

  connect() {
    console.log("KnowledgeBaseController connected?")
  }

  search() {
    clearTimeout(this.searchTimeout)
    this.searchTimeout = setTimeout(() => this.formTarget.requestSubmit(), 250)
  }

  toggleCategory(event) {
    const category = event.currentTarget
    if (!category.open) {
      this.pauseVideos(category)
      return
    }

    this.categoryTargets.forEach(other => {
      if (other !== category) other.open = false
    })
    this.itemTargets.forEach(item => {
      item.open = false
      this.pauseVideos(item)
    })
  }

  toggleItem(event) {
    const item = event.currentTarget
    if (!item.open) {
      this.pauseVideos(item)
      return
    }

    this.itemTargets.forEach(other => {
      if (other !== item) {
        other.open = false
        this.pauseVideos(other)
      }
    })
  }

  disconnect() {
    clearTimeout(this.searchTimeout)
    this.pauseVideos(this.element)
  }

  pauseVideos(container) {
    container.querySelectorAll("video").forEach(video => video.pause())
  }
}
